import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";

@Component({
    selector: 'mwp-wizard-error',
    templateUrl: './wizard-error.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WizardErrorComponent implements OnInit {
    @Input() public errorBenefitName: string;
    @Input() public errorPanelName: string;
    @Input() public errorWizardName: string;
    @Input() public displayReturnButton: boolean = true;

    constructor(
        private enrollmentManagerService: EnrollmentManagerService,
    ) {
    }

    ngOnInit(): void {
        if (!this.errorWizardName)
            this.errorWizardName = this.enrollmentManagerService.benefitWizardControlPanel.wizardType;

        if (!this.errorBenefitName)
            this.errorBenefitName = this.enrollmentManagerService.benefitWizardControlPanel.enrollmentName;

        if (!this.errorPanelName)
            this.errorPanelName = this.enrollmentManagerService.benefitWizardControlPanel.panel;
    }

    public cancelWizard(): void {
        this.enrollmentManagerService.$CancelBenefitWizard.next(true);
    }
}